<template>
  <div class="bg-gradient-to-r from-psychology-warm to-psychology-calm rounded-2xl shadow-lg border border-psychology-primary-20 p-6">
    <div class="flex items-center gap-3 mb-4">
      <span class="text-3xl">🚀</span>
      <h3 class="text-xl font-semibold text-psychology-primary">个性化建议</h3>
    </div>

    <ul class="space-y-3">
      <li 
        v-for="(advice, index) in adviceList" 
        :key="index"
        class="flex items-start gap-3 p-3 bg-white/80 rounded-lg"
      >
        <div class="w-5 h-5 rounded-full border-2 border-psychology-info flex items-center justify-center flex-shrink-0 mt-0.5">
          <span class="text-psychology-info text-xs font-bold">✓</span>
        </div>
        <span class="text-gray-700 text-sm leading-relaxed">{{ advice }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'PersonalizedAdvice',
  props: {
    aypScore: {
      type: Number,
      required: true,
      validator: (value) => value >= 0 && value <= 100
    }
  },
  computed: {
    adviceList() {
      if (this.aypScore >= 80) {
        return [
          '寻找能够提供稳定性和安全感的年长伴侣',
          '学习在依赖和独立之间找到平衡点',
          '培养自己的独立性，避免过度依赖伴侣',
          '寻找能够尊重你成长空间的伴侣',
          '与伴侣建立清晰的沟通模式，表达你的情感需求',
          '保持个人兴趣爱好，确保在关系中有足够的自我空间'
        ]
      } else if (this.aypScore >= 60) {
        return [
          '寻找能够提供指导但尊重你独立性的伴侣',
          '培养自己的决策能力，减少对伴侣的过度依赖',
          '学习在关系中表达自己的需求和界限',
          '寻找能够共同成长和学习的伴侣',
          '建立健康的依赖模式，避免过度独立或过度依赖',
          '重视伴侣的情绪稳定性和责任感'
        ]
      } else if (this.aypScore >= 40) {
        return [
          '寻找能够相互支持和理解的伴侣',
          '继续维持关系中的平衡和相互尊重',
          '关注伴侣的情感需求，建立深度连接',
          '培养共同兴趣爱好，增强关系纽带',
          '保持开放沟通，及时调整关系中的不平衡',
          '重视伴侣的性格特质和价值观匹配度'
        ]
      } else if (this.aypScore >= 20) {
        return [
          '寻找能够带来活力和新鲜感的伴侣',
          '学习在引导和跟随之间灵活转换',
          '保持个人空间的独立性',
          '寻找能够欣赏你创造力和活力的伴侣',
          '建立充满乐趣和探索的关系模式',
          '平衡关系中的稳定性和新鲜感'
        ]
      } else {
        return [
          '寻找能够欣赏你成熟和经验的年轻伴侣',
          '学习给予伴侣适当的自由和成长空间',
          '避免过度控制，尊重伴侣的独立性',
          '寻找能够激发你活力和创造力的伴侣',
          '与伴侣建立平等的沟通模式，避免单向指导',
          '保持开放心态，学习从年轻伴侣身上获取新视角'
        ]
      }
    }
  }
}
</script>

